<!--
  * name: PageTitle
  * description: 페이지 타이틀 컴포넌트
-->
<template>
  <div class="container tit-style">
    <h1><slot/></h1>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
};
</script>

<style></style>
